module.exports = {"airport-food-court":{"name":"Naruta Airport Food Court"},"airport-gate":{"name":"the gate you just arrived at"}}


//////////////////
// WEBPACK FOOTER
// ./src/data/locations.json
// module id = 87
// module chunks = 0